import { render, staticRenderFns } from "./Surplus.vue?vue&type=template&id=04ea228e&scoped=true"
import script from "./Surplus.vue?vue&type=script&lang=js"
export * from "./Surplus.vue?vue&type=script&lang=js"
import style0 from "./Surplus.vue?vue&type=style&index=0&id=04ea228e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea228e",
  null
  
)

export default component.exports